// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { defer } from 'rxjs';
import { map } from 'rxjs/operators';
import { batchSearchRecipientStatusRequestToJson, batchSearchRecipientStatusResponseFromJson, resetRecipientStatusRequestToJson, resubscribeRecipientStatusRequestToJson, setOpenTrackingConsentRequestToJson, unsubscribeRecipientStatusRequestToJson } from './codec';
import { fetchRpc } from '@vendasta/protos/fetch-transport';
import { getGlobalTransport } from '@vendasta/protos/transport';
export async function resetRecipientStatus(request) {
    await fetchRpc('email.v1.RecipientStatus/ResetRecipientStatus', resetRecipientStatusRequestToJson(request));
}
export function resetRecipientStatus$(request, options) {
    return defer(() => resetRecipientStatusWithTransport$(getGlobalTransport(), request, options));
}
export function resetRecipientStatusWithTransport$(transport, request, options) {
    return transport
        .post('email.v1.RecipientStatus/ResetRecipientStatus', resetRecipientStatusRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function batchSearchRecipientStatus(request) {
    const raw = await fetchRpc('email.v1.RecipientStatus/BatchSearchRecipientStatus', batchSearchRecipientStatusRequestToJson(request));
    return batchSearchRecipientStatusResponseFromJson(raw);
}
export function batchSearchRecipientStatus$(request, options) {
    return defer(() => batchSearchRecipientStatusWithTransport$(getGlobalTransport(), request, options));
}
export function batchSearchRecipientStatusWithTransport$(transport, request, options) {
    return transport
        .post('email.v1.RecipientStatus/BatchSearchRecipientStatus', batchSearchRecipientStatusRequestToJson(request), options)
        .pipe(map(resp => batchSearchRecipientStatusResponseFromJson(resp)));
}
export async function resubscribeRecipientStatus(request) {
    await fetchRpc('email.v1.RecipientStatus/ResubscribeRecipientStatus', resubscribeRecipientStatusRequestToJson(request));
}
export function resubscribeRecipientStatus$(request, options) {
    return defer(() => resubscribeRecipientStatusWithTransport$(getGlobalTransport(), request, options));
}
export function resubscribeRecipientStatusWithTransport$(transport, request, options) {
    return transport
        .post('email.v1.RecipientStatus/ResubscribeRecipientStatus', resubscribeRecipientStatusRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function unsubscribeRecipientStatus(request) {
    await fetchRpc('email.v1.RecipientStatus/UnsubscribeRecipientStatus', unsubscribeRecipientStatusRequestToJson(request));
}
export function unsubscribeRecipientStatus$(request, options) {
    return defer(() => unsubscribeRecipientStatusWithTransport$(getGlobalTransport(), request, options));
}
export function unsubscribeRecipientStatusWithTransport$(transport, request, options) {
    return transport
        .post('email.v1.RecipientStatus/UnsubscribeRecipientStatus', unsubscribeRecipientStatusRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function setOpenTrackingConsent(request) {
    await fetchRpc('email.v1.RecipientStatus/SetOpenTrackingConsent', setOpenTrackingConsentRequestToJson(request));
}
export function setOpenTrackingConsent$(request, options) {
    return defer(() => setOpenTrackingConsentWithTransport$(getGlobalTransport(), request, options));
}
export function setOpenTrackingConsentWithTransport$(transport, request, options) {
    return transport
        .post('email.v1.RecipientStatus/SetOpenTrackingConsent', setOpenTrackingConsentRequestToJson(request), options)
        .pipe(map(() => undefined));
}
